<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    timer: null,
  }),
  methods: {
    handlerInput(event) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$emit('input', event.target.value || '');
      }, 500);
    },
  },
};
</script>
<template>
  <div
    class="template-filter-input"
  >
    <i class="el-icon-search"></i>
    <input
      type="text"
      placeholder="Фильтр"
      :value="value"
      @input="handlerInput"
    >
  </div>
</template>
<style lang="scss">
  .template-filter-input {
    display: flex;
    font-size: 18px;
    align-items: center;
    position: relative;
    height: 100%;
    width: 100%;

    i {
      font-size: 18px;
    }

    input {
      border: none;
      outline: none;
      padding: 0 8px;
      font-size: 16px;
      line-height: 24px;
      width: 100%;
      height: 100%;
      background: none;
    }
  }
</style>
